import { BinaryOption } from '../../../../../enums';

export const getDebriefStatus = () => {
    return [
        { name: 'Completed', value: BinaryOption.FALSE },
        { name: 'Open', value: BinaryOption.TRUE },
    ];
};
